import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { QairoLogo } from "../components/QairoLogo";
import { HeroSection } from "../components/landing/HeroSection";
import { FeaturesSection } from "../components/landing/FeaturesSection";
import { PricingSection } from "../components/landing/PricingSection";
import { TestimonialsSection } from "../components/landing/TestimonialsSection";

const STEPS = [
  { step: "01", title: "Choose Content Type", desc: "Select from blog posts, ads, social media, emails, or images" },
  { step: "02", title: "Describe Your Needs", desc: "Tell our AI what you want - topic, tone, and style" },
  { step: "03", title: "Get Results", desc: "Receive high-quality content in seconds, ready to use" },
];

export default function LandingPage() {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-white/70 border-b border-black">
        <div className="max-w-7xl mx-auto px-8 py-4 flex items-center justify-between">
          <Link to="/" data-testid="logo">
            <QairoLogo variant="light" />
          </Link>
          <nav className="hidden md:flex items-center gap-8">
            <a href="#features" className="text-sm font-medium hover:text-[#0066FF] transition-colors" data-testid="nav-features">Features</a>
            <a href="#pricing" className="text-sm font-medium hover:text-[#0066FF] transition-colors" data-testid="nav-pricing">Pricing</a>
            <a href="#testimonials" className="text-sm font-medium hover:text-[#0066FF] transition-colors" data-testid="nav-testimonials">Testimonials</a>
          </nav>
          <div className="flex items-center gap-4">
            {user ? (
              <Link to="/dashboard" className="bg-[#0066FF] text-white px-6 py-2 font-bold hover:bg-[#0052CC] transition-colors rounded-lg" data-testid="dashboard-btn">
                Dashboard
              </Link>
            ) : (
              <>
                <Link to="/login" className="text-sm font-medium hover:text-[#0066FF] transition-colors" data-testid="login-btn">
                  Login
                </Link>
                <Link to="/register" className="bg-[#0066FF] text-white px-6 py-2 font-bold hover:bg-[#0052CC] transition-colors rounded-lg" data-testid="get-started-btn">
                  Get Started
                </Link>
              </>
            )}
          </div>
        </div>
      </header>

      <HeroSection />

      {/* Stats */}
      <section className="py-16 px-8 bg-black text-white">
        <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          <div><p className="text-4xl font-black">10K+</p><p className="text-sm text-gray-400 mt-2">Active Users</p></div>
          <div><p className="text-4xl font-black">1M+</p><p className="text-sm text-gray-400 mt-2">Content Generated</p></div>
          <div><p className="text-4xl font-black">85%</p><p className="text-sm text-gray-400 mt-2">Time Saved</p></div>
          <div><p className="text-4xl font-black">4.9</p><p className="text-sm text-gray-400 mt-2">User Rating</p></div>
        </div>
      </section>

      <FeaturesSection />

      {/* How It Works */}
      <section className="py-24 px-8 md:px-16 bg-[#F4F4F5]">
        <div className="max-w-7xl mx-auto">
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#0066FF] mb-4 text-center">How It Works</p>
          <h2 className="text-3xl sm:text-4xl tracking-tight font-bold text-center mb-16">Three Steps to Amazing Content</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {STEPS.map((item) => (
              <div key={item.step} className="text-center">
                <div className="text-6xl font-black text-[#0066FF]/20 mb-4">{item.step}</div>
                <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <PricingSection />
      <TestimonialsSection />

      {/* CTA */}
      <section className="py-24 px-8 md:px-16">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl tracking-tight font-bold mb-6">Ready to Create Amazing Content?</h2>
          <p className="text-gray-600 mb-8">Join 10,000+ marketers creating better content faster. Start free today.</p>
          <Link to="/register" className="inline-block bg-[#0066FF] text-white px-8 py-4 font-bold hover:bg-[#0052CC] transition-all hover:-translate-y-1 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]" data-testid="cta-final">
            Start Creating Free
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-12 px-8 border-t border-black bg-black text-white">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <QairoLogo variant="dark" />
          <p className="text-sm text-gray-400">&copy; 2026 QAIRO AI. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
